"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformToDate = void 0;
const class_transformer_1 = require("class-transformer");
const TransformToDate = (target, propertyKey) => {
    (0, class_transformer_1.Type)(() => Date)(target, propertyKey);
    (0, class_transformer_1.Transform)(({ value }) => (value ? new Date(value) : undefined))(target, propertyKey);
};
exports.TransformToDate = TransformToDate;
//# sourceMappingURL=transformToDate.js.map